import React from 'react';
import PropTypes from 'prop-types';
import {Container} from './button_group.styled';
import {Button} from './button';
export const ButtonGroup = ({children, onButtonClick}) => {
	const childrenArray = React.Children.toArray(children);
	const childrenLength = childrenArray.length;
	const selectedElement = childrenArray.findIndex(child => !!child.props.isSelected);

	const getBorderProps = (index, selectedElement, childrenLength) => {
		let left = true;
		let right = true;

		// check for outermost elements
		left = left && index !== 0;
		right = right && index !== childrenLength - 1;
		// check if selected or selected is next to this element
		left = left && index !== selectedElement && index - 1 !== selectedElement;
		right = right && index !== selectedElement && index + 1 !== selectedElement;
		return {right, left};
	};
	return (
		<Container>
			{React.Children.map(children, (child, i) => {
				const value = child.props.value || child.props.children;
				return React.cloneElement(child, {
					...getBorderProps(i, selectedElement, childrenLength),
					onClick: onButtonClick,
					value,
				});
			})}
		</Container>
	);
};

ButtonGroup.Button = Button;

ButtonGroup.propTypes = {
	/**
	 * children - Only Components of type ButtonGroup.Button
	 */
	children: PropTypes.node.isRequired,
	/**
	 * (value) => void
	 * returns value fo the button clicked
	 */
	onButtonClick: PropTypes.func,
};

ButtonGroup.defaultProps = {
	onButtonClick: () => false,
};
